import { render } from "./MainSlide.vue?vue&type=template&id=ccf6ff46&scoped=true"
import script from "./MainSlide.vue?vue&type=script&lang=js"
export * from "./MainSlide.vue?vue&type=script&lang=js"

import "./MainSlide.vue?vue&type=style&index=0&id=ccf6ff46&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bomoindustrial-vue/bomoindustrial-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf6ff46"]])

export default __exports__